const defaultTheme = require('tailwindcss/defaultTheme');
const { themeSchema } = require('./theme-schema');
const tailwindPlugin = require('./tailwind').default;
module.exports = {
    mode: 'jit',
    content: [
        '../*.{js,ts,jsx,tsx}',
    ],
    darkMode: 'media',
    theme: {
        extend: {
            fontFamily: {
                header: ['var(--font-header, var(--font-default))', ...defaultTheme.fontFamily.sans],
                sans: ['var(--font-default)', ...defaultTheme.fontFamily.sans],
            },
            screens: {
                sm: '640px',
                md: '768px',
                lg: '1024px',
                xl: '1400px',
            },
            maxWidth: {
                page: '120rem',
            },
            padding: {
                base: 'var(--spacing-base)',
                large: 'var(--spacing-large)',
                small: 'var(--spacing-small)',
            },
            margin: {
                base: 'var(--spacing-base)',
                large: 'var(--spacing-large)',
                small: 'var(--spacing-small)',
            },
            space: {
                base: 'var(--spacing-base)',
                large: 'var(--spacing-large)',
                small: 'var(--spacing-small)',
            },
            gap: {
                grid: 'var(--spacing-grid)',
                base: 'var(--spacing-base)',
                large: 'var(--spacing-large)',
                small: 'var(--spacing-small)',
            },
        },
    },
    plugins: [
        require('tailwindcss-rtl'),
        tailwindPlugin(themeSchema),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/aspect-ratio'),
    ],
};
//# sourceMappingURL=tailwind.config.js.map